module.exports = __webpack_public_path__ + "static/media/488ba196.jpg";